export default {
  query_settings: {
    company_fields: [],
    user_fields: [],
    custom_fields: [],
  },
}
